import { browserHistory } from 'common/utils/browserHistory';

export default function goToInvoicesIndex() {
    browserHistory.push('/invoices/open');
  }
